"use client";
import { ModalContextProvider as NaNModalContextProvider } from "@notanumber/nan-component-library";

const ModalContextProvider = ({children}) => {
  return ( <NaNModalContextProvider>{children}</NaNModalContextProvider> );
}
 
export default ModalContextProvider;